module.exports = __webpack_public_path__ + "img/await.9cad3521.png";